import { render, staticRenderFns } from "./AccettazioneNominaENG.vue?vue&type=template&id=15a2f74e&"
import script from "./AccettazioneNominaENG.vue?vue&type=script&lang=js&"
export * from "./AccettazioneNominaENG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports